import React from "react";
import "./styles.scss";

const TrialOffers = ({
  openBooking,
  trialOffers,
}: {
  openBooking: () => void;
  trialOffers: {
    id: number;
    name: string;
    lessons: {
      minPrice: number;
      languageId: number;
    }[];
  }[];
}) => {
  return (
    <div className="trial-scroll">
      {trialOffers?.length > 0 &&
        trialOffers[0]?.lessons?.map((item) => (
          <div key={item?.languageId} className="trial-card">
            <div className="dot-badge">
              <div className="dot" />
              <span className="trial-text">Trial Lesson Available</span>
            </div>

            <div className="language-badge">
              <span className="amount language">{trialOffers[0]?.name}</span>
              <span className="amount">
                <span
                  style={{ textDecorationLine: "line-through", marginRight: 3 }}
                >
                  USD {item?.minPrice}
                </span>
                <span>Free</span>
                <span className="duration">/30 mins</span>
              </span>
            </div>

            <button onClick={() => openBooking()} className="book-button">
              Book Trial Lesson
            </button>
          </div>
        ))}
    </div>
  );
};

export default TrialOffers;
